<h2 mat-dialog-title id="reautentisering-dialog-tittel">{{ "Bekreft din identitet"|translate }}</h2>

@if (modus() == 'eid') {
  <mat-dialog-content>
    <p>{{ melding }}</p>
    <criipto-autentisering-popup [criiptoResponsHandler]="criiptoResponsHandler" [eidmetoder]="aktiverteEidMetoder" (vedValgt)="eidMetodeValgt.set(true)"/>
    @if (eidMatcherIkkeInnloggetBruker()) {
      <inline-melding type="feil">{{'Du må bruke en BankID som brukeren din er knyttet til, vennligst forsøk på nytt.'|translate}}</inline-melding>
    }
    @if(!eidMetodeValgt()){
      <a (click)="reautentiserMedPassord()">{{'Bekreft med passord'|translate}}</a>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
  </mat-dialog-actions>

} @else {
  <form [formGroup]="passordSkjema" (ngSubmit)="passordAngitt()">
    <mat-dialog-content>
      <p>{{ melding }}</p>
      <mat-form-field>
        <mat-label>{{ 'Passord'|translate }}</mat-label>
        <input matInput [formControl]="passordSkjema.controls.passord" data-testid="reautentisering-dialog-passord-felt" #passordfelt>
        @if (passordSkjema.controls.passord.hasError('ugyldigPassord')) {
          <mat-error data-testid="ugyldigPassord">{{ 'Ugyldig passord' | translate }}</mat-error>
        }
      </mat-form-field>
      @if (brukerHarEidAktivert) {
        <a (click)="reautentiserMedEid()">{{'Bekreft med BankID'|translate}}</a>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="primary" type="submit" cdkFocusInitial
              [disabled]="passordSkjema.invalid || arbeider()" [visSpinner]="arbeider()"
              spinnerTekst="{{'Bekrefter...'|translate}}" data-testid="bekreft">
        {{ 'Bekreft'|translate }}
      </button>
    </mat-dialog-actions>
  </form>
}
